export const scroll = {
  scrollBehavior: {
    scale: true,
  },
  scrollSnapAlign: {
    scale: true,
  },
  scrollSnapStop: {
    scale: true,
  },
  scrollSnapType: {
    scale: true,
  },
  scrollMargin: {
    scale: 'space',
  },
  scrollMarginTop: {
    scale: 'space',
  },
  scrollMarginRight: {
    scale: 'space',
  },
  scrollMarginBottom: {
    scale: 'space',
  },
  scrollMarginLeft: {
    scale: 'space',
  },
  scrollMarginX: {
    scale: 'space',
    properties: ['scrollMarginLeft', 'scrollMarginRight'],
  },
  scrollMarginY: {
    scale: 'space',
    properties: ['scrollMarginTop', 'scrollMarginBottom'],
  },
  scrollPadding: {
    scale: 'space',
  },
  scrollPaddingTop: {
    scale: 'space',
  },
  scrollPaddingRight: {
    scale: 'space',
  },
  scrollPaddingBottom: {
    scale: 'space',
  },
  scrollPaddingLeft: {
    scale: 'space',
  },
  scrollPaddingX: {
    scale: 'space',
    properties: ['scrollPaddingLeft', 'scrollPaddingRight'],
  },
  scrollPaddingY: {
    scale: 'space',
    properties: ['scrollPaddingTop', 'scrollPaddingBottom'],
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Scroll = typeof scroll;
